module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (11).4c489c88.jpg";